export default __webpack_public_path__ + "static/media/bigtime.b149c531.png";